import { navigate } from '@reach/router'
import React, { useEffect, useState } from 'react'
import { TemplateProps } from '../../../journeys/journey/Interfaces'
import { Card, Typography } from "@material-ui/core";
import { Button, Spinner } from 'ams-ui-reactkit';
import { Dialog, TitleBlock } from '../../../atoms';
import './CustAckVerification.scss'
import { ItemBlock } from '../../../organisms';
import { getBolandMoveDetails } from '../../../graphql/getAckDetails.query';
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from '../../../context';
import { getParsedValue } from "./../../../common/ParseScript";
import { AMSAccordion, DataBlock } from '../../../molecules';
import { getCustomerId } from './../../../utils/Utils';
import actionTypeConstants from './../../../utils/actionTypeConstants'
import { getPackMaterials } from '../../../graphql/getPackageMaterials.query';


const CustAckVerification: React.FC<TemplateProps> = (props: any) => {
    const { templateProps } = props;
    const [loading, setLoading] = useState(false);
    const [popLoading, setPopLoading] = useState(false);
    const customerInfoState: any = useContextSelector(StoreContext, store => store?.appState?.customerInfo);
    const customerId = getCustomerId() || ""
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const bolDetails = customerInfoState?.bolDetails || [];
    const appState: any = useContextSelector(StoreContext, store => store?.appState);

    const [selectedData, SetSelectedData] = useState<any>(null)
    useEffect(() => {
        if (customerId && bolDetails?.length === 0) {
            getBolDetailsData()
        }
    }, [])


    const getBolDataStructure = (data: any) => {
        let Arry = []

        if (data) {
            if (data?.bolDetails?.moverCarrier) {
                Arry.push(data?.bolDetails?.moverCarrier)
            }
            if (data?.bolDetails?.customerDetails) {
                Arry.push(data?.bolDetails?.customerDetails)
            }
            if (data?.bolDetails?.serviceDates) {
                Arry.push(data?.bolDetails?.serviceDates)
            }
            if (data?.moveChargesService?.chargesService) {
                Arry.push(data?.moveChargesService?.chargesService)
            }
            if (data?.getAckDetails) {
                Arry.push(data?.getAckDetails)
            }
        }

        return Arry
    }

    const getBolDetailsData = async () => {
        setLoading(true)
        await getBolandMoveDetails(customerId).then((dataResults: any) => {
            let bolDataStructure = getBolDataStructure(dataResults) || []
            dispatch({
                'type': actionTypeConstants.UPDATE_DP_DETAILS,
                'payload': bolDataStructure
            })
            setLoading(false)
        }).catch((e: any) => {
            console.log("getBolDetails API Failed ln:35 Error:", e);
            setLoading(false)
        });
    }

    const handleSubItemClick = async (item: any) => {
        setLoading(true)
        setPopLoading(true)
        if (item.hasSubContent) {
            let respData = await getPackMaterials(customerId)
            if (respData) {
                SetSelectedData(respData)
            }
        }
        setLoading(false)
    }

    const handleClosePopup = () => {
        SetSelectedData(null)
        setPopLoading(false)
    }

    return (
        <div className="baseContainerBlock ackHouseHolds">
            <div className="ackTitleBlock">
                {templateProps.title && <TitleBlock title={getParsedValue(templateProps.title, appState)} />}
                {
                    templateProps.subtitle &&
                    <Typography variant="body1" variantMapping={{ body1: "div" }} className='color-grey'>
                        {templateProps.subtitle}
                    </Typography>
                }
            </div>
            {loading ? <div className='flex-center-50h'>
                <Spinner />
            </div> : bolDetails && bolDetails.length > 0 &&

            <Card className="cardStylesSecondary">
                <div>
                    {bolDetails && bolDetails.map((item: any, i: any) => <ItemBlock key={i} {...item} onClickSubitem={handleSubItemClick} />)}
                </div>
            </Card>}
            <div className="staticFixedButton">
                <Button
                    text={templateProps?.button}
                    onClick={() => { navigate(templateProps?.nextScreen || '/') }}
                    color="primary"
                    variant="contained"
                    size="large"
                />
            </div>
            {popLoading && <Dialog title={selectedData?.title} open={true} fullwidth={true} handleClose={handleClosePopup}>
                {loading ? <div className="loader">
                    <Spinner />
                </div> :
                    <React.Fragment>
                        {
                            selectedData?.section?.length && <AMSAccordion list={selectedData?.section} />
                        }
                        {(selectedData?.dataItems?.length || selectedData?.rowItems?.length) &&
                            <div className={`itemBlockDiv`}>
                                <DataBlock key={1} {...selectedData} title="" variant={true} />
                            </div>
                        }
                    </React.Fragment>
                }
            </Dialog>}
        </div>
    )
}

export default CustAckVerification